let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kcSpx")).then(() => parcelRequire('7utIF'));